import Home from './pages/home/Home';
import DashboardSecretary from './pages/dashboard-secretary/DashboardSecretary';
import MemberList from './pages/member/member-list/MemberList';
import UserList from './pages/user/user-list/UserList';
import CongregationList from './pages/congregation/congregation-list/CongregationList';
import DashboardUmadeub from './pages/umadeub/dashboard-umadeub/DashboardUmadeub';
import {
  faChalkboardUser,
  faFire,
  faFolderOpen,
  faGear,
  faHandHoldingDollar,
  faHome,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { authenticationService } from './services/auth.service';
import OrderList from './pages/order/order-list/OrderList';
import DashboardCampaign from './pages/campaign/dashboard-campaign/DashboardCampaign';
import JobSkipList from './pages/configuration/job/job-skip-list/JobSkipList';
import DashboardEvent from './pages/event-person/dashboard-event/DashboardEvent';

export const getRoutes = () => [
  {
    path: '/inicio',
    icon: faHome,
    label: 'Início',
    component: Home
  },
  {
    path: '/membros',
    icon: faUsers,
    label: 'Membros',
    component: MemberList,
    allowed: authenticationService.accessMembersRoles()
  },
  {
    path: '/secretaria',
    icon: faFolderOpen,
    label: 'Secretaria',
    component: DashboardSecretary,
    allowed: authenticationService.accessSecretaryRoles()
  },
  {
    path: '/campanhas',
    icon: faHandHoldingDollar,
    label: 'Campanha',
    component: DashboardCampaign,
    allowed: authenticationService.accessFinanceRoles('campaign')
  },
  {
    path: '/campanhas/pessoas',
    icon: faHandHoldingDollar,
    label: 'Campanha',
    component: DashboardCampaign,
    allowed: authenticationService.accessAuxCampaignRoles()
  },
  {
    path: '/eventos',
    icon: faChalkboardUser,
    label: 'Eventos',
    component: DashboardEvent,
    allowed: authenticationService.accessEventRoles()
  },
  {
    path: '/umadeub',
    icon: faFire,
    label: 'UMADEUB',
    allowed: authenticationService.accessAdminYouthRoles(),
    children: [
      {
        path: '/umadeub',
        label: 'Dashboard',
        component: DashboardUmadeub,
        allowed: authenticationService.accessAdminYouthRoles()
      },
      {
        path: '/pedidos/umadeub',
        label: 'Pedidos',
        component: OrderList,
        allowed: authenticationService.accessAdminYouthRoles()
      },
    ],
  },
  {
    path: '/sistema',
    icon: faGear,
    label: 'Sistema',
    allowed: authenticationService.accessAdminRoles(),
    children: [
      {
        path: '/sistema/usuarios',
        label: 'Usuários',
        component: UserList,
        allowed: authenticationService.accessAdminRoles()
      },
      {
        path: '/sistema/congregacoes',
        label: 'Congregações',
        component: CongregationList,
        allowed: authenticationService.accessAdminRoles('congregation')
      },
      {
        path: '/sistema/jobs',
        label: 'Config. Jobs',
        component: JobSkipList,
        allowed: authenticationService.accessAdminRoles('routine')
      },
    ],
  },
];

export default getRoutes;
